import dayjs from 'dayjs';
import { DataGridIdentifiers } from '../components/Interface';
import { DocStatus } from '../config/document';
import { DocumentType } from '../config/DocumentType';
import { v4 as uuidv4 } from 'uuid';
import addNotification from './addNotification';
import { NotificationType } from '../config';
import { DocumentDirection } from '../config/DocumentDirection';

const PURCHASE_ORDER_EMPTY_HEADER_FIELDS = {
  companyId: null,
  companyName: null,
  companyCode: null,
  companyContactId: null,
  currencyCode: null,
  paymentMethodId: null,
  billingAdressId: null,
  billingCountry: null,
  billingProvince: null,
  billingPostCode: null,
  billingCity: null,
  billingStreetAddress: null,
  shippingAdressId: null,
  shippingCountry: null,
  shippingProvince: null,
  shippingPostCode: null,
  shippingCity: null,
  shippingStreetAddress: null,
  deliverymethodId: null,
  incotermCode: null,
  priceListId: null,
  langCode: null,
  hunTaxNumber: null,
  euTaxNumber: null,
  foreignTaxNumber: null,
  incotermCity: null,
  companyWarning: null,
  shortName: null,
};

const PURCHASE_ORDER_EMPTY_LINE_FIELDS = {
  unitPrice: null,
  vatCode: null,
  netPrice: null,
  grossPrice: null,
  grossUnitPrice: null,
  baseUnitPrice: null,
  baseGrossUnitPrice: null,
  vatValueInOwnCur: null,
  netPriceInOwnCur: null,
  grossPriceInOwnCur: null,
  vatValue: null,
  vatPercent: null,
};

export const getDocDataGridIdentifiers = (docTypeId) => {
  switch (parseInt(docTypeId)) {
    case DocumentType.SalesQuotation:
      return {
        doc: DataGridIdentifiers.SalesQuotationDoc,
        docLine: DataGridIdentifiers.SalesQuotationDocLine,
      };
    case DocumentType.CustomerOrder:
      return {
        doc: DataGridIdentifiers.CustomerOrderDoc,
        docLine: DataGridIdentifiers.CustomerOrderDocLine,
      };
    case DocumentType.Delivery:
      return {
        doc: DataGridIdentifiers.DeliveryNoteDoc,
        docLine: DataGridIdentifiers.DeliveryNoteDocLine,
      };
    case DocumentType.Return:
      return {
        doc: DataGridIdentifiers.ReturnDoc,
        docLine: DataGridIdentifiers.ReturnDocLine,
      };
    case DocumentType.DownPaymentRequest:
      return {
        doc: DataGridIdentifiers.DownPaymentRequestDoc,
        docLine: DataGridIdentifiers.DownPaymentRequestDocLine,
      };
    case DocumentType.DownPayment:
      return {
        doc: DataGridIdentifiers.DownPaymentDoc,
        docLine: DataGridIdentifiers.DownPaymentDocLine,
      };
    case DocumentType.ARInvoice:
      return {
        doc: DataGridIdentifiers.ARInvoiceDoc,
        docLine: DataGridIdentifiers.ARInvoiceDocLine,
      };
    case DocumentType.PurchaseRequest:
      return {
        doc: DataGridIdentifiers.PurchaseRequestDoc,
        docLine: DataGridIdentifiers.PurchaseRequestDocLine,
      };
    case DocumentType.PurchaseQuotation:
      return {
        doc: DataGridIdentifiers.PurchaseQuotationDoc,
        docLine: DataGridIdentifiers.PurchaseQuotationDocLine,
      };
    case DocumentType.PurchaseOrder:
      return {
        doc: DataGridIdentifiers.PurchaseOrderDoc,
        docLine: DataGridIdentifiers.PurchaseOrderDocLine,
      };
    case DocumentType.PurchaseDelivery:
      return {
        doc: DataGridIdentifiers.PurchaseDeliveryNoteDoc,
        docLine: DataGridIdentifiers.PurchaseDeliveryNoteDocLine,
      };
    case DocumentType.GoodsReturn:
      return {
        doc: DataGridIdentifiers.GoodsReturnDoc,
        docLine: DataGridIdentifiers.GoodsReturnDocLine,
      };
    case DocumentType.APDownPaymentRequest:
      return {
        doc: DataGridIdentifiers.APDownPaymentRequestDoc,
        docLine: DataGridIdentifiers.APDownPaymentRequestDocLine,
      };
    case DocumentType.PurchaseAdvanceInvoice:
      return {
        doc: DataGridIdentifiers.PurchaseAdvanceInvoiceDoc,
        docLine: DataGridIdentifiers.PurchaseAdvanceInvoiceDocLine,
      };
    case DocumentType.APInvoice:
      return {
        doc: DataGridIdentifiers.APInvoiceDoc,
        docLine: DataGridIdentifiers.APInvoiceDocLine,
      };
    case DocumentType.PurchaseOrderVariant:
      return {
        doc: DataGridIdentifiers.PurchaseOrderVariantDoc,
        docLine: DataGridIdentifiers.PurchaseOrderVariantDocLine,
      };
    case DocumentType.InventoryTransfer:
      return {
        doc: DataGridIdentifiers.InventoryTransferDoc,
        docLine: DataGridIdentifiers.InventoryTransferDocLine,
      };
    case DocumentType.GoodsReceipt:
    case DocumentType.ConversionReceipt:
      return {
        doc: DataGridIdentifiers.GoodsReceiptDoc,
        docLine: DataGridIdentifiers.GoodsReceiptDocLine,
      };
    case DocumentType.GoodsIssue:
    case DocumentType.ConversionIssue:
      return {
        doc: DataGridIdentifiers.GoodsIssueDoc,
        docLine: DataGridIdentifiers.GoodsIssueDocLine,
      };
    case DocumentType.ProjectIssue:
      return {
        doc: DataGridIdentifiers.ProjectIssueDoc,
        docLine: DataGridIdentifiers.ProjectIssueDocLine,
      };
    case DocumentType.CooperationIssue:
      return {
        doc: DataGridIdentifiers.CooperationIssueDoc,
        docLine: DataGridIdentifiers.CooperationIssueDocLine,
      };
    case DocumentType.EmployeeIssue:
      return {
        doc: DataGridIdentifiers.EmployeeIssueDoc,
        docLine: DataGridIdentifiers.EmployeeIssueDocLine,
      };
    case DocumentType.InventoryCounting:
      return {
        doc: DataGridIdentifiers.InventoryCountingDoc,
        docLine: DataGridIdentifiers.InventoryCountingDocLine,
      };
    case DocumentType.InventoryCountingDif:
      return {
        doc: DataGridIdentifiers.InventoryCountingDifDoc,
        docLine: DataGridIdentifiers.InventoryCountingDifDocLine,
      };
    case DocumentType.ReceiptFromProduction:
      return {
        doc: DataGridIdentifiers.ReceiptFromProductionDoc,
        docLine: DataGridIdentifiers.ReceiptFromProductionDocLine,
      };
    case DocumentType.IssueForProduction:
      return {
        doc: DataGridIdentifiers.IssueForProductionDoc,
        docLine: DataGridIdentifiers.IssueForProductionDocLine,
      };
    case DocumentType.ProductionOrder:
      return {
        doc: DataGridIdentifiers.ProductionOrderDoc,
        docLine: DataGridIdentifiers.ProductionOrderDocLine,
      };
    case DocumentType.IssueForService:
      return {
        doc: DataGridIdentifiers.IssueForServiceDoc,
        docLine: DataGridIdentifiers.IssueForServiceDocLine,
      };
    case DocumentType.ReceiptFromService:
      return {
        doc: DataGridIdentifiers.ReceiptFromServiceDoc,
        docLine: DataGridIdentifiers.ReceiptFromServiceDocLine,
      };
    case DocumentType.ReturnFromProduction:
      return {
        doc: DataGridIdentifiers.ReturnFromProductionDoc,
        docLine: DataGridIdentifiers.ReturnFromProductionDocLine,
      };
    case DocumentType.ReturnFromIssue:
      return {
        doc: DataGridIdentifiers.ReturnFromIssueDoc,
        docLine: DataGridIdentifiers.ReturnFromIssueDocLine,
      };
    case DocumentType.ProjectReturn:
      return {
        doc: DataGridIdentifiers.ProjectReturnDoc,
        docLine: DataGridIdentifiers.ProjectReturnDocLine,
      };
    case DocumentType.CooperationReturn:
      return {
        doc: DataGridIdentifiers.CooperationReturnDoc,
        docLine: DataGridIdentifiers.CooperationReturnDocLine,
      };
    case DocumentType.EmployeeReturn:
      return {
        doc: DataGridIdentifiers.EmployeeReturnDoc,
        docLine: DataGridIdentifiers.EmployeeReturnDocLine,
      };
    default:
      return DataGridIdentifiers.documentReports;
  }
};

export const getSourceDocDataGridIdentifiers = (docTypeId) => {
  switch (parseInt(docTypeId)) {
    case DocumentType.SalesQuotation:
      return {
        sourceDoc: DataGridIdentifiers.SourceSalesQuotationDoc,
        sourceDocLine: DataGridIdentifiers.SourceSalesQuotationDocLine,
      };
    case DocumentType.CustomerOrder:
      return {
        sourceDoc: DataGridIdentifiers.SourceCustomerOrderDoc,
        sourceDocLine: DataGridIdentifiers.SourceCustomerOrderDocLine,
      };
    case DocumentType.Delivery:
      return {
        sourceDoc: DataGridIdentifiers.SourceDeliveryNoteDoc,
        sourceDocLine: DataGridIdentifiers.SourceDeliveryNoteDocLine,
      };
    case DocumentType.Return:
      return {
        sourceDoc: DataGridIdentifiers.SourceReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceReturnDocLine,
      };
    case DocumentType.DownPaymentRequest:
      return {
        sourceDoc: DataGridIdentifiers.SourceDownPaymentRequestDoc,
        sourceDocLine: DataGridIdentifiers.SourceDownPaymentRequestDocLine,
      };
    case DocumentType.DownPayment:
      return {
        sourceDoc: DataGridIdentifiers.SourceDownPaymentDoc,
        sourceDocLine: DataGridIdentifiers.SourceDownPaymentDocLine,
      };
    case DocumentType.ARInvoice:
      return {
        sourceDoc: DataGridIdentifiers.SourceARInvoiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceARInvoiceDocLine,
      };
    case DocumentType.PurchaseRequest:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseRequestDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseRequestDocLine,
      };
    case DocumentType.PurchaseQuotation:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseQuotationDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseQuotationDocLine,
      };
    case DocumentType.PurchaseOrder:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseOrderDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseOrderDocLine,
      };
    case DocumentType.PurchaseDelivery:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseDeliveryNoteDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseDeliveryNoteDocLine,
      };
    case DocumentType.GoodsReturn:
      return {
        sourceDoc: DataGridIdentifiers.SourceGoodsReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceGoodsReturnDocLine,
      };
    case DocumentType.APDownPaymentRequest:
      return {
        sourceDoc: DataGridIdentifiers.SourceAPDownPaymentRequestDoc,
        sourceDocLine: DataGridIdentifiers.SourceAPDownPaymentRequestDocLine,
      };
    case DocumentType.PurchaseAdvanceInvoice:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseAdvanceInvoiceDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseAdvanceInvoiceDocLine,
      };
    case DocumentType.APInvoice:
      return {
        sourceDoc: DataGridIdentifiers.SourceAPInvoiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceAPInvoiceDocLine,
      };
    case DocumentType.PurchaseOrderVariant:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseOrderVariantDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseOrderVariantDocLine,
      };
    case DocumentType.InventoryTransfer:
      return {
        sourceDoc: DataGridIdentifiers.SourceInventoryTransferDoc,
        sourceDocLine: DataGridIdentifiers.SourceInventoryTransferDocLine,
      };
    case DocumentType.GoodsReceipt:
    case DocumentType.ConversionReceipt:
      return {
        sourceDoc: DataGridIdentifiers.SourceGoodsReceiptDoc,
        sourceDocLine: DataGridIdentifiers.SourceGoodsReceiptDocLine,
      };
    case DocumentType.GoodsIssue:
    case DocumentType.ConversionIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceGoodsIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceGoodsIssueDocLine,
      };
    case DocumentType.ProjectIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceProjectIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceProjectIssueDocLine,
      };
    case DocumentType.CooperationIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceCooperationIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceCooperationIssueDocLine,
      };
    case DocumentType.EmployeeIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceEmployeeIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceEmployeeIssueDocLine,
      };
    case DocumentType.InventoryCounting:
      return {
        sourceDoc: DataGridIdentifiers.SourceInventoryCountingDoc,
        sourceDocLine: DataGridIdentifiers.SourceInventoryCountingDocLine,
      };
    case DocumentType.InventoryCountingDif:
      return {
        sourceDoc: DataGridIdentifiers.SourceInventoryCountingDifDoc,
        sourceDocLine: DataGridIdentifiers.SourceInventoryCountingDifDocLine,
      };
    case DocumentType.ReceiptFromProduction:
      return {
        sourceDoc: DataGridIdentifiers.SourceReceiptFromProductionDoc,
        sourceDocLine: DataGridIdentifiers.SourceReceiptFromProductionDocLine,
      };
    case DocumentType.IssueForProduction:
      return {
        sourceDoc: DataGridIdentifiers.SourceIssueForProductionDoc,
        sourceDocLine: DataGridIdentifiers.SourceIssueForProductionDocLine,
      };
    case DocumentType.ProductionOrder:
      return {
        sourceDoc: DataGridIdentifiers.SourceProductionOrderDoc,
        sourceDocLine: DataGridIdentifiers.SourceProductionOrderDocLine,
      };
    case DocumentType.IssueForService:
      return {
        sourceDoc: DataGridIdentifiers.SourceIssueForServiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceIssueForServiceDocLine,
      };
    case DocumentType.ReceiptFromService:
      return {
        sourceDoc: DataGridIdentifiers.SourceReceiptFromServiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceReceiptFromServiceDocLine,
      };
    case DocumentType.ReturnFromProduction:
      return {
        sourceDoc: DataGridIdentifiers.SourceReturnFromProductionDoc,
        sourceDocLine: DataGridIdentifiers.SourceReturnFromProductionDocLine,
      };
    case DocumentType.ReturnFromIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceReturnFromIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceReturnFromIssueDocLine,
      };
    case DocumentType.ProjectReturn:
      return {
        sourceDoc: DataGridIdentifiers.SourceProjectReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceProjectReturnDocLine,
      };
    case DocumentType.CooperationReturn:
      return {
        sourceDoc: DataGridIdentifiers.SourceCooperationReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceCooperationReturnDocLine,
      };
    case DocumentType.EmployeeReturn:
      return {
        sourceDoc: DataGridIdentifiers.SourceEmployeeReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceEmployeeReturnDocLine,
      };
    default:
      return DataGridIdentifiers.documentReports;
  }
};

export const getDocumentTypeKeyUpperCase = (value) => {
  return Object.entries(DocumentType)
    .find(([_, v]) => v === parseInt(value))?.[0]
    ?.toUpperCase();
};

export const extractCopyPayload = (
  selectedValues,
  newDocType = null,
  defVals = {},
  docName = '',
  currDocTypeId = null
) => {
  const nowIso = dayjs().toISOString();
  const resolvedCompanyCode = selectedValues?.companyCode ?? selectedValues?.company?.code ?? '';
  const resolvedCompanyName = selectedValues?.companyName ?? selectedValues?.company?.name ?? '';

  const shouldClearPurchaseOrderFields =
    (parseInt(newDocType) === DocumentType.PurchaseOrder ||
      parseInt(newDocType) === DocumentType.PurchaseOrderVariant) &&
    parseInt(currDocTypeId) === DocumentType.CustomerOrder;

  const baseHeader = {
    ...selectedValues,
    docNum: '',
    customStatus: null,
    customDocStatus: null,
    docDate: newDocType ? nowIso : selectedValues.docDate,
    issueDate: nowIso,
    dueDate: newDocType ? nowIso : selectedValues.dueDate,
    docStatus: newDocType ? DocStatus.OPENED : DocStatus.CANCELLATION,
    docTypeId: newDocType ?? selectedValues.docTypeId,
    mode: 'copy',
    note: `Forrása: ${docName} ${selectedValues.docNum}`,
    balanceSettled: false,
    settledAmount: null,
    openAmount: null,
    companyCode: resolvedCompanyCode,
    companyName: resolvedCompanyName,
    settlement: [],

    ...(shouldClearPurchaseOrderFields && PURCHASE_ORDER_EMPTY_HEADER_FIELDS),
  };
  delete baseHeader.supportingDocumentAssignment;

  if (parseInt(newDocType) === DocumentType.DownPaymentRequest) {
    if (!defVals.itemCode) {
      addNotification({
        content: 'Hiányzik az alapértelmezett cikk kódja!',
        type: NotificationType.ERROR,
      });
      return;
    }

    const unitPrice = selectedValues?.netInDocCur ?? 0;
    const vatCode = selectedValues?.docLine?.[0]?.vatCode ?? defVals?.vatCode;
    const vatPercent = selectedValues?.docLine?.[0]?.vatPercent ?? defVals?.vatPercent;

    const oneLine = {
      ...defVals,
      id: uuidv4(),
      isNew: true,
      qty: 1,
      unitPrice,
      vatPercent,
      vatCode,
      baseId: selectedValues.docId,
      baseDocnum: selectedValues.docNum,
      baseDocType: selectedValues.docTypeId,
      baseLine: null,
      dueDate: nowIso,
    };

    return {
      ...baseHeader,
      docLine: [oneLine],
    };
  }

  const docLine = (selectedValues?.docLine || [])
    .filter((line) => line?.lineStatus === DocStatus.OPENED && line?.opnQty > 0)
    .map((line) => ({
      ...line,
      id: uuidv4(),
      isNew: true,
      baseId: line.baseId ?? selectedValues.docId,
      baseDocnum: line.baseDocnum ?? selectedValues.docNum,
      baseDocType: line.baseDocType ?? selectedValues.docTypeId,
      baseLine: newDocType ? line.lineNum : line.baseLine,
      qty: line.opnQty,
      opnQty: 0,
      cplQty: 0,
      dueDate: nowIso,
      lineStatus: newDocType ? line.lineStatus : DocStatus.CANCELLATION,

      ...(shouldClearPurchaseOrderFields && PURCHASE_ORDER_EMPTY_LINE_FIELDS),
    }));

  const selectedItemCodes = new Set(docLine.map((line) => line.itemCode).filter(Boolean));

  return {
    ...baseHeader,
    ...(Array.isArray(selectedValues?.supportingDocumentAssignment)
      ? {
          supportingDocumentAssignment: selectedValues.supportingDocumentAssignment.filter((assignment) =>
            selectedItemCodes.has(assignment.itemCode)
          ),
        }
      : {}),
    docLine,
  };
};

export const isCellEditable = ({ currentDocType, selectedValues }) => {
  return ({ field, row }) => {
    if (selectedValues.docStatus === DocStatus.PLANNED) return true;
    if (field === 'itemName' && !currentDocType?.editableItemName) return false;
    if (field === 'whsCode' && currentDocType?.inventoryAccounting && !row?.isNew) return false;
    if (field === 'qty' && currentDocType.inventoryAccounting && !row?.isNew && selectedValues.mode !== 'copy')
      return false;
    if (field === 'itemCode' && !row?.isNew) return false;
    if (
      field === 'netPrice' &&
      (currentDocType?.direction !== DocumentDirection.INCOMING || !currentDocType?.invoice)
    ) {
      return false;
    }
    if (field === 'toWhsCode' && currentDocType?.direction !== DocumentDirection.INTERNAL) return false;
    if (field === 'toBinId' && currentDocType?.direction !== DocumentDirection.INTERNAL) return false;

    return true;
  };
};

export const getLineEditableFields = (apiRef, rowId, { currentDocType, selectedValues }) => {
  const allCols = apiRef.current.getVisibleColumns?.() ?? [];
  const row = apiRef.current.getRow?.(rowId);
  const canEdit = isCellEditable({ currentDocType, selectedValues });

  const editableFields = allCols
    .filter((c) => c.type !== 'actions' && c.editable)
    .filter((c) => {
      return canEdit({ field: c.field, row });
    })
    .map((c) => c.field);

  return editableFields;
};
